import React, {useEffect, useState} from "react";
import {doc, getDoc} from "firebase/firestore";
import {useParams} from "react-router-dom";
import {db} from "../../firebase/FirebaseProvider";
import {Location, User} from "../types/Types";
import PageTracking from "../auth/PageTracking";
import UserDetailsV2 from "./UserDetailsV2";
import UserVisits from "./tabs/UserVisits";

interface Props {
  currentUser: User | undefined;
  locations: Array<Location> | undefined;
}

function UserOverview(props: Props) {
  const {id} = useParams<{id: string}>();
  const [user, setUser] = useState<User | undefined>(undefined);
  const isUiV2 = !!props.currentUser?.enableUiV2;

  useEffect(() => {
    if (!id) {
      return;
    }

    (async () => {
      const userSnap = await getDoc(doc(db, "users", id));
      if (userSnap.exists()) {
        setUser({...userSnap.data(), id: userSnap.id} as User);
      }
    })();
  }, [id]);

  return (
    <>
      <PageTracking />
      {props.currentUser && (isUiV2
        ? <UserDetailsV2 currentUser={props.currentUser} user={user} locations={props.locations} />
        : <UserVisits currentUser={props.currentUser} locations={props.locations} />)}
    </>
  );
}

export default UserOverview;
